var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logged-in"},[(!_vm.ready)?_c('loading'):_c('div',{staticClass:"main"},[_c('notifications'),_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }